import React, {useEffect, useState} from 'react';
import HeaderComponent from './components/header/Header';
import Intro from "./components/intro/Intro";
import SliderCarousel from "./components/introSliders2/SliderCarousel";
import WhatIDo from "./components/whatIDo/WhatIDo";
import Projects from "./components/projects/Projects";
import Footer from "./components/footer/Footer";
import AnimatedTransitionVertical from "./components/AnimatedTransitionVertical";
import Hero from './components/header/Hero';

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [showSliders, setShowSliders] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowIntro(!showIntro);
    }, 1500);
    setTimeout(() => {
      setShowSliders(!showSliders);
    }, 1600);
  }, []);

  return (
    <>
      {!showIntro && <HeaderComponent />}
      <Intro />
      <AnimatedTransitionVertical isVisible={showSliders}>
        <>
        <div className="Common-container" style={{marginTop: 140}}>
          <Hero />
        </div>
         
          {/* <div className="Slider-container">
            <SliderCarousel />
          </div> */}

          <Projects />
          
          {/* <div className="Common-container">
            <WhatIDo />
          </div> */}

          <div className="Common-container">
            <Footer />
          </div>
        </>
      </AnimatedTransitionVertical>
    </>
  );
}

export default App;
